import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  const errorMsg =
    'Missing Supabase environment variables. Please check your .env file.';
  console.error(errorMsg);
  throw new Error(errorMsg);
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true, // Confie nisso!
    persistSession: true,
    detectSessionInUrl: true, // Mantenha se usar Magic Links ou OAuth redirects
    // flowType: 'pkce', // Considere usar PKCE se possível, mas 'implicit' funciona
  },
  // Outras configurações globais ou de db podem permanecer se necessárias
  // global: { headers: { 'Content-Type': 'application/json' } },
  // db: { schema: 'public' },
  // realtime: { params: { eventsPerSecond: 10 } },
});
